var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 156,
    viewBox: "0 0 176 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.899 132.709L100.73 7.41797C97.9788 2.76188 93.1111 0.0105591 87.8201 0.0105591C82.5291 0.0105591 77.6614 2.76188 74.91 7.41797L2.10581 133.556C-1.91535 140.751 0.201052 150.275 8.8783 154.508C10.5714 155.354 12.4762 155.778 14.3809 155.778H160.836H162.741C166.55 155.778 170.36 153.873 172.476 150.698C176.709 144.349 176.286 137.577 172.899 132.709ZM82.9524 104.349L79.5661 39.7989C85.9153 39.7989 88.0317 39.7989 96.0741 39.7989L92.2645 104.349H82.9524ZM95.2275 132.497C93.3227 134.402 90.5714 135.672 87.8201 135.672C85.0688 135.672 82.3175 134.614 80.4127 132.497C78.5079 130.381 77.2381 127.841 77.2381 124.878C77.2381 121.915 78.2963 119.376 80.4127 117.471C82.5291 115.566 85.0688 114.296 87.8201 114.296C90.5714 114.296 93.3227 115.354 95.2275 117.471C97.1323 119.376 98.4021 122.127 98.4021 124.878C98.4021 127.841 97.3439 130.593 95.2275 132.497Z",
    fill: "#EC3939"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.bf12fb32352f5ed354a4fac97f96b892.svg";
export { ForwardRef as ReactComponent };